import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Observable } from "rxjs";
import { APIUrl } from "src/app/features-common/constants/APIUrls";
import { BaseService } from "src/app/framework/services/base.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class InvoiceService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  generateNewInvoiceNumber(): Observable<any> {
    return this.httpService.get(APIUrl.getNewInvoiceNumber);
  }

  createNewInvoioce(formData): Observable<any> {
    return this.httpService.post(APIUrl.invoice, formData);
  }

  updateInvoice(formData): Observable<any> {
    return this.httpService.put(APIUrl.invoice, formData);
  }

  getAllInvoices(): Observable<any> {
    return this.httpService.get(APIUrl.allInvoices);
  }

  getInvoicebyId(id: number): Observable<any> {
    let url = `${APIUrl.allInvoices}/${id}`;
    return this.httpService.get(url);
  }

  getAllInvoicesRange(startDate, endDate): Observable<any> {
    let params = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    return this.httpService.getParams(APIUrl.allInvoices, params);
  }

  getPendingAmountData(startDate, endDate): Observable<any> {
    let params = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    return this.httpService.getParams(APIUrl.pendingPayments, params);
  }

  getInvoicePreviewUnsaved(invoiceRequestBody): Observable<any> {
    return this.httpService.post(APIUrl.invoicePreview, invoiceRequestBody);
  }

  getInvoicePreview(invoiceId): Observable<any> {
    return this.httpService.get(`${APIUrl.invoicePreview}/${invoiceId}`);
  }

  rejectManualInvoice(invoiceId) {
    let params = new HttpParams().set("invoiceId", invoiceId);
    return this.httpService.getParams(APIUrl.rejectInvoice, params);
  }

  getInvoicePdf(invoiceId): Observable<any> {
    // return this.httpService.get(url)
    let url = `${environment.hostUrl}:${environment.port}/${APIUrl.invoicePreview}/${invoiceId}/${APIUrl.downloadPdf}`;
    return this.http.get(url, { responseType: "blob" as "json" });
  }

  gertInvoicePreviewPdf(invoiceId): Observable<any> {
    let url = `${APIUrl.invoicePreview}/${invoiceId}/${APIUrl.invoicePreviewPdf}`;
    return this.httpService.get(url);
  }

  previewBeforeSave(formData): Observable<any> {
    let url = `${environment.hostUrl}:${environment.port}/${APIUrl.invoicePreviewBeforeSave}`;
    return this.http.post(url, formData, { responseType: "blob" as "json" });
  }

  emailInvoice(emails, invoiceId): Observable<any> {
    let url = APIUrl.emailInvoice;
   
    let params = new HttpParams()
      .set("emails", emails)
      .set("invoiceId", invoiceId);
    return this.httpService.getParams(url, params);
  }
  getinvoicepayments(startDate, endDate): Observable<any> {
    let params = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    return this.httpService.getParams(APIUrl.invoicepayments, params);
  }

  getitemcodes() {
    return this.httpService.get(APIUrl.itemcodes);
  }
}
